import React from 'react';
import { T, fontBody } from './tokens';

export default function StatusPill({ status }) {
  const active = status === 'Active';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      padding: '4px 10px', borderRadius: 999,
      background: active ? T.greenSoft : '#F1F2F5',
      color: active ? T.green : T.slate,
      fontSize: 12, fontWeight: 600, fontFamily: fontBody,
    }}
    >
      <span style={{ width: 6, height: 6, borderRadius: 999, background: active ? T.green : T.slateLight }} />
      {status}
    </span>
  );
}
